module.exports = __webpack_public_path__ + "img/bazar_casa_vieja.71561f96.jpeg";